module.exports = __webpack_public_path__ + "static/media/feelingProud.3adbee3e.svg";